import { render, staticRenderFns } from "./OverflowTooltip.vue?vue&type=template&id=33f4fc46&scoped=true"
import script from "./OverflowTooltip.vue?vue&type=script&lang=js"
export * from "./OverflowTooltip.vue?vue&type=script&lang=js"
import style0 from "./OverflowTooltip.vue?vue&type=style&index=0&id=33f4fc46&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33f4fc46",
  null
  
)

export default component.exports